import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Manifesto from "@/components/landing/Manifesto";
import Features from "@/components/landing/Features";
import AccessSection from "@/components/landing/AccessSection";
import ReleaseBanner from "@/components/landing/ReleaseBanner";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  const lenisRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const reducedMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;
    const saveData = navigator.connection?.saveData;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: !reducedMotion && !saveData });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      if (!document.hidden) rafId = requestAnimationFrame(raf);
    };
    const onVisibility = () => {
      cancelAnimationFrame(rafId);
      if (!document.hidden) rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    document.addEventListener("visibilitychange", onVisibility);

    const anchors = document.querySelectorAll('a[href^="#"]');
    const onClick = (e) => {
      const href = e.currentTarget.getAttribute("href");
      if (href && href.length > 1) {
        e.preventDefault();
        lenis.scrollTo(href, { offset: -64 });
      }
    };
    anchors.forEach((a) => a.addEventListener("click", onClick));
    return () => {
      cancelAnimationFrame(rafId);
      document.removeEventListener("visibilitychange", onVisibility);
      lenis.destroy();
      anchors.forEach((a) => a.removeEventListener("click", onClick));
    };
  }, []);

  useEffect(() => {
    if (!location.hash) return undefined;
    const timer = window.setTimeout(() => {
      lenisRef.current?.scrollTo(location.hash, { offset: -64, immediate: true });
    }, 0);
    return () => window.clearTimeout(timer);
  }, [location.hash]);

  const scrollToAccess = () => lenisRef.current?.scrollTo("#access", { offset: -64 });

  return (
    <div id="top" className="min-h-screen bg-transparent" data-testid="landing-page">
      <Navbar onAccess={scrollToAccess} />
      <Hero onRequestAccess={scrollToAccess} />
      <Marquee />
      <Manifesto />
      <Features />
      <AccessSection />
      <Footer />
      <ReleaseBanner />
    </div>
  );
}
